module.exports = __webpack_public_path__ + "img/abeja_logo_mono.1b85c16b.png";